import {base, baseConfig} from '../Services/api';

export function getPlandayStatus() {
  return fetch(`${base}auth/planday/status`, baseConfig);
}

export function getPlandayAuthorizationUrl() {
  return fetch(`${base}auth/planday`, baseConfig);
}

export function getPlandaySchedule() {
  return fetch(`${base}planday/schedule`, baseConfig);
}

export function importPlandaySchedule() {
  return fetch(`${base}planday/schedule/import`, {
    method: 'POST',
    body: JSON.stringify({}),
    ...baseConfig
  });
}

export function importPlandayPayArrangements() {
  return fetch(`${base}planday/pay-arrangements/import`, {
    method: 'POST',
    body: JSON.stringify({}),
    ...baseConfig
  });
}

export function getPlandayShifts(dates = {}) {
  const query = new URLSearchParams(dates).toString();
  return fetch(`${base}planday/shifts${query ? `?${query}` : ''}`, baseConfig);
}

export function importPlandayShifts(dates = {}) {
  return fetch(`${base}planday/shifts/import`, {
    method: 'POST',
    body: JSON.stringify(dates),
    ...baseConfig
  });
}

export function getPlandayDepartments() {
  return fetch(`${base}planday/departments`, baseConfig);
}

export function assignPlandayDepartment(departmentId, siteId, options = {}) {
  return fetch(`${base}planday/departments/${encodeURIComponent(departmentId)}/site`, {
    method: 'PUT',
    body: JSON.stringify({siteId: siteId || null, ...options}),
    ...baseConfig
  });
}
